import { createSelector } from 'reselect'
import { AppState } from 'Store'

const selectPlatformEntries = (state: AppState) =>
	state.advertisement.platform.platforms_list.entries
const selectTotal = (state: AppState) => state.advertisement.platform.platforms_list.total_entries

const selectCurrentParams = (state: AppState) => state.advertisement.platform.requestParams

const getPlatId = createSelector(selectPlatformEntries, (plat) =>
	plat.map((plat) => ({
		id: plat.id,
		name: `${plat.id} ${plat.name}`,
	}))
)

export const platformSelector = {
	selectPlatformEntries,
	selectCurrentParams,
	selectTotal,
	getPlatId,
}
